import { render, staticRenderFns } from "./DropMenu.vue?vue&type=template&id=53b37a2a&scoped=true&"
import script from "./DropMenu.vue?vue&type=script&lang=js&"
export * from "./DropMenu.vue?vue&type=script&lang=js&"
import style0 from "./DropMenu.vue?vue&type=style&index=0&id=53b37a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b37a2a",
  null
  
)

export default component.exports